import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[alphanumericdirective]',
    standalone: false
})
export class AlphaNumericDirective {
  constructor(
    private el: ElementRef,
    private control: NgControl
  ) {}

  @HostListener('input', ['$event']) public onEvent($event) {
    let value = this.el.nativeElement.value.replace(/[^a-zA-Z0-9]+/g, '');
    this.control.control.setValue(value);
  }
}
